<template>
  <div>
    <v-card :elevation="elevation">
      <v-card-title class="pl-0 pt-0">
        <v-tabs v-model="tab" right>
          <v-tab :href="'#temperatura'">Temperatura (ºC)</v-tab>
          <v-tab :href="'#humedad'">Humedad relativa (%)</v-tab>
          <v-tab :href="'#viento'">Velocidad del viento (m/seg)</v-tab>
        </v-tabs>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-tabs-items v-model="tab">

            <v-tab-item :value="0">
              <line-chart :chart-data="temperaturaData"/>
            </v-tab-item>

            <v-tab-item :value="'temperatura'">
              <line-chart :chart-data="temperaturaData"/>
            </v-tab-item>

            <v-tab-item :value="'humedad'">
              <bar-chart :chart-data="humedadData"/>
            </v-tab-item>

            <v-tab-item :value="'viento'">
              <bar-chart :chart-data="vientoData"/>
            </v-tab-item>

          </v-tabs-items>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import BarChart from '@/components/charts/BarChart'
import LineChart from '@/components/charts/LineChart'
import moment from 'moment'

export default {
  props: {
    flat: { type: Boolean, default: false}
  },
  components: {
    LineChart,
    BarChart
  },
  mounted () {
    this.temperaturaFillData()
    this.humedadFillData()
    this.vientoFillData()
  },
  created () {
    this.tab = 'tempratura'
  },
  data: () => ({
    tab: null,
    temperaturaData: null,
    humedadData: null,
    vientoData: null
  }),
  watch: {
    tab (val) {
      if (val === 'temperatura') this.temperaturaFillData()
      if (val === 'humedad') this.humedadFillData()
      if (val === 'viento') this.vientoFillData()
    }
  },
  computed: {
    elevation () {
      return this.flat ? 0 : 1
    }
  },
  methods: {
    temperaturaFillData () {
      const hours = []
      const data = []
      for (let i=0; i < 25; i++) {
        hours.push(i)
        data.push(this.getRandomInt(-20, 60))
      }
      this.temperaturaData = {
        labels: hours,
        datasets: [
          {
            label: moment().format('DD-MM-YYYY'),
            borderColor: '#FF9800',
            backgroundColor: 'transparent',
            data: data
          },
        ]
      }
    },
    humedadFillData () {
      const hours = []
      const data1 = []
      const data2 = []
      for (let i=0; i < 25; i++) {
        hours.push(i)
        data1.push(this.getRandomInt(0, 100))
        data2.push(this.getRandomInt(0, 100))
      }
      this.humedadData = {
        labels: hours,
        datasets: [
          {
            label: 'Intervención 1',
            backgroundColor: '#FF9800',
            data: data1
          },
          {
            label: 'Intervención 2',
            backgroundColor: '#2196F3',
            data: data2
          }
        ]
      }
    },
    vientoFillData () {
      const hours = []
      const data1 = []
      const data2 = []
      for (let i=0; i < 25; i++) {
        hours.push(i)
        data1.push(this.getRandomInt(0, 40))
        data2.push(this.getRandomInt(0, 40))
      }
      this.vientoData = {
        labels: hours,
        datasets: [
          {
            label: 'Intervención 1',
            backgroundColor: '#FF9800',
            data: data1
          },
          {
            label: 'Intervención 2',
            backgroundColor: '#2196F3',
            data: data2
          }
        ]
      }
    },
    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    },
  }
}
</script>

<style>

</style>